import type { Components } from 'react-markdown'

// Pull the article slug out of a help link. `/docs/<slug>` opens in the reader;
// `/docs/category/...` and in-scene `#...` anchors do not.
function docsSlug(href: string): string | null {
  const match = href.match(/^(?:https?:\/\/[^/]+)?\/docs\/([^/#?]+)\/?$/)
  if (!match || match[1] === 'category') return null
  return match[1]
}

// Markdown overrides for the help surface. Links keep citations inside the
// surface (internal article opens in the reader, in-scene anchor is plain text,
// everything else a new tab). The `li` keeps a bold at the start of a list item
// inline; the shared component blocks it out for the AI-analysis report, which
// help doesn't want.
export function helpMarkdownComponents(
  onOpenArticle: (slug: string) => void,
): Partial<Components> {
  const linkClass =
    'font-medium text-brand underline decoration-brand/40 underline-offset-2 hover:decoration-brand transition-colors cursor-pointer'
  return {
    li: ({ children }) => <li className="leading-7 text-blue-7">{children}</li>,
    a: ({ href, children }) => {
      const target = href ?? ''
      const slug = docsSlug(target)
      if (slug) {
        return (
          <button
            type="button"
            className={linkClass}
            onClick={() => onOpenArticle(slug)}
          >
            {children}
          </button>
        )
      }
      if (target.startsWith('#')) {
        return <span className="text-blue-7">{children}</span>
      }
      return (
        <a
          href={target}
          target="_blank"
          rel="noopener noreferrer"
          className={linkClass}
        >
          {children}
        </a>
      )
    },
  }
}
